import React from 'react';

export function StepSubjectLabel() {
  return <>Předmět podání</>;
}
